/* eslint-disable default-case */
/* eslint-disable import/prefer-default-export */

import React from 'react';
import WaEventAltaOroButton from './WaEventAltaOroButton';
import WaEventHazteOroButton from './WaEventHazteOroButton';
import WaEventOroLink from './WaEventOroLink';
import { WaEventsConstants } from './WaEventsConstants';
import WaMenuOroLink from './WaMenuOroLink';
import WaMenuMastercardLink from './WaMenuMastercardLink';
import WaMenuSocioClubLink from './WaMenuSocioClubLink';

export class WaEventConponentFactory {
  t: (arg0: string) => string;

  constructor(translation: any) {
    this.t = translation;
  }

  getComponent = (componentLabel: string, onclickMethod?: any, data?: any) => {
    switch (componentLabel) {
      default:
        return null;
      case WaEventsConstants.ORO_BAJA:
        return this.getBajaOroLink(onclickMethod);
      case WaEventsConstants.CALCULADORA:
        return this.getCalculadoraLink(onclickMethod);
      case WaEventsConstants.ORO_IMPAGOS:
        return this.getImpagosLink(onclickMethod);
      case WaEventsConstants.ALTA_ORO_COMPLETAR:
        return this.getCompletarOroButton();
      case WaEventsConstants.ALTA_ORO:
        return this.getAltaOroButton(data ? data.cuota : 4);
      case WaEventsConstants.ORO:
        return this.getHazteOroButtonFromTarjetas(onclickMethod);
      case WaEventsConstants.MENU_ORO:
        return this.getHazteOroLink();
      case WaEventsConstants.MENU_MASTERCARD:
        return this.getHazteMastercardLink();
      case WaEventsConstants.MENU_SOCIO_CLUB:
        return this.getHazteSocioClubLink();
    }
  };

  private getBajaOroLink = (onclickMethod: any) => {
    return (
      <>
        <WaEventOroLink
          button_text={this.t('tarjetas.tarjeta-oro-datos.request-out')}
          button_class="link link-oro"
          hittype={WaEventsConstants.HITTYPE_EVENT}
          event_category={WaEventsConstants.CATEGORY_CTA}
          event_action={WaEventsConstants.ACTION_CLUB}
          event_label={WaEventsConstants.ORO_BAJA}
          onclick={onclickMethod}
        />
      </>
    );
  };

  private getImpagosLink = (onclickMethod: any) => {
    return (
      <>
        <WaEventOroLink
          button_text={this.t(
            'tarjetas.tarjeta-oro-datos.pay-pending-fee-button',
          )}
          button_class="btn btn-oro"
          hittype={WaEventsConstants.HITTYPE_EVENT}
          event_category={WaEventsConstants.CATEGORY_CTA}
          event_action={WaEventsConstants.ACTION_CLUB}
          event_label={WaEventsConstants.ORO_IMPAGOS}
          onclick={onclickMethod}
        />
      </>
    );
  };

  private getCalculadoraLink = (onclickMethod: any) => {
    return (
      <>
        <WaEventOroLink
          button_text={this.t('tarjetas.tarjeta-oro-datos.calc-saving')}
          button_class="btn btn-oro calcular"
          hittype={WaEventsConstants.HITTYPE_EVENT}
          event_category={WaEventsConstants.CATEGORY_CTA}
          event_action={WaEventsConstants.ACTION_CLUB}
          event_label={WaEventsConstants.CALCULADORA}
          data_js={WaEventsConstants.DATA_JS_SAVING}
          onclick={onclickMethod}
        />
      </>
    );
  };

  private getCompletarOroButton = () => {
    return (
      <>
        <WaEventAltaOroButton
          button_text={this.t('tarjetas.tarjeta-oro-datos.completar-tus-datos')}
          button_id="fact-oro-btn"
          button_class="btn btn-oro"
          hittype={WaEventsConstants.HITTYPE_EVENT}
          event_category={WaEventsConstants.CATEGORY_CTA}
          event_action={WaEventsConstants.ACTION_CLUB}
          event_label={WaEventsConstants.ALTA_ORO_COMPLETAR}
          data_button={WaEventsConstants.DATA_BUTTON_INCOMPLETE}
        />
      </>
    );
  };

  private getHazteOroButtonFromTarjetas = (onClickMethod: void) => {
    return (
      <WaEventHazteOroButton
        button_text={this.t('tarjetas.tarjeta-socio.to-request')}
        button_id="hazte-oro-btn"
        button_class="btn btn-oro"
        hittype={WaEventsConstants.HITTYPE_EVENT}
        event_category={WaEventsConstants.CATEGORY_TARJETAS_SOLICITAR_ORO}
        event_action={WaEventsConstants.ACTION_CLUB}
        event_label={WaEventsConstants.ORO}
        onClickMethod={onClickMethod}
      />
    );
  };

  private getAltaOroButton = (cuota: number) => {
    return (
      <>
        <WaEventAltaOroButton
          button_text={this.t('tarjetas.hazte-oro.to-request')}
          button_id="fact-oro-btn"
          button_class="btn btn-oro"
          hittype={WaEventsConstants.HITTYPE_EVENT}
          event_category={WaEventsConstants.CATEGORY_CTA}
          event_action={WaEventsConstants.ACTION_CLUB}
          event_label={WaEventsConstants.ALTA_ORO}
          data_button={WaEventsConstants.DATA_BUTTON_CONFIRM}
          event_value={cuota !== undefined ? cuota.toString() : ''}
        />
      </>
    );
  };

  private getHazteOroLink = () => {
    return (
      <>
        <WaMenuOroLink
          hittype={WaEventsConstants.HITTYPE_EVENT}
          event_category={WaEventsConstants.CATEGORY_MENU_SOLICITAR_TARJETA}
          event_action={WaEventsConstants.ACTION_CLUB}
          event_label={WaEventsConstants.ORO}
        />
      </>
    );
  };

  private getHazteMastercardLink = () => {
    return (
      <>
        <WaMenuMastercardLink
          hittype={WaEventsConstants.HITTYPE_EVENT}
          event_category={WaEventsConstants.CATEGORY_MENU_SOLICITAR_TARJETA}
          event_action={WaEventsConstants.ACTION_CLUB}
          event_label={WaEventsConstants.MASTERCARD}
        />
      </>
    );
  };

  private getHazteSocioClubLink = () => {
    return (
      <WaMenuSocioClubLink
        hittype={WaEventsConstants.HITTYPE_EVENT}
        event_category={WaEventsConstants.CATEGORY_MENU_SOLICITAR_TARJETA}
        event_action={WaEventsConstants.ACTION_CLUB}
        event_label={WaEventsConstants.SOCIO_CLUB}
      />
    );
  };
}
